import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Layout/Header/Header";
import Sidebar from "./Layout/Sidebar/Sidebar";
import Footer from "./Layout/Footer/Footer";

const Admin = () => {
  return (
    <div className="flex">
      {/* Sticky Sidebar */}
      <div className="fixed top-0 left-0 h-screen bg-white z-40">
        <Sidebar />
      </div>

      {/* Main Content Area (with left margin to accommodate sidebar) */}
      <div className="flex-1 ml-64 flex flex-col">
        {/* Sticky Header */}
        <div className="sticky top-0 z-50 bg-white">
          <Header />
        </div>

        {/* Scrollable Main Content */}
        <main className="min-h-[calc(100vh-80px)] p-4 bg-[#F9F7FF]">
          <Outlet />
        </main>
      {/* <div className='px-3'>

        <Footer />
      </div> */}
      </div>
    </div>
  );
};

export default Admin;
